import AdminUsers from './AdminUsers'

export default AdminUsers
